import { createI18n } from 'vue-i18n'

const messages = {
  en: {
    welcome: "Welcome",
    login: "Login",
    sidebar: {
      dashboard: "Dashboard",
      checklist: "CheckList",
      manpower: "Manpower",
      users: "Users",
      audits: "Audits",
      onboarding: "Onboarding",
      contracts: "Contracts",
      staffDirectory: "Staff Directory",
      attendance: "Attendance",
      leaveManagement: "Leave Management",
      loansAdvance: "Loans & Advance",
      appraisals: "Appraisals",
      trainingDevelopment: "Training & Development",
      discipline: "Discipline",
      hrReports: "HR Reports",
      masterData: "Master Data",
      departments: "Departments",
      positions: "Positions",
      contractTypes: "Contract Types",
      processTypes: "Process Types",
      allowances: "Allowances",
      contractStatus: "Contract Status",
      agencies: "Agencies",
      leaveTypes: "Leave Types",
      interviewQuestions: "Interview Questions",
      interviewEvaluation: "Interview Evaluation",
      employeeActions: "Employee Actions",
      attendanceStatus: "Attendance Status",
      workingHours: "Working Hours",
      sections: "Sections",
      classes: "Classes",
      subjects: "Subjects",
      modules: "Modules",
      permissions: "Permissions",
      userPermission: "User Permission"
    }
  },

  fr: {
    welcome: "Bienvenue",
    login: "Connexion",
    sidebar: {
      dashboard: "Tableau de bord",
      checklist: "Liste de contrôle",
      users: "Utilisateurs",
      manpower: "Main-d'œuvre",
      audits: "Audits",
      onboarding: "Intégration",
      contracts: "Contracts",
      staffDirectory: "Annuaire du personnel",
      attendance: "Présence",
      leaveManagement: "Gestion des congés",
      loansAdvance: "Prêts et avances",
      appraisals: "Évaluations",
      trainingDevelopment: "Formation et développement",
      discipline: "Discipline",
      hrReports: "Rapports RH",
      masterData: "Données de base",
      departments: "Départements",
      positions: "Postes",
      contractTypes: "Types de contrat",
      processTypes: "Types de processus",
      allowances: "Indemnités",
      contractStatus: "Statut des contrats",
      agencies: "Agences",
      leaveTypes: "Types de congé",
      interviewQuestions: "Questions d'entretien",
      interviewEvaluation: "Évaluation d'entretien",
      employeeActions: "Actions des employés",
      attendanceStatus: "Statut de présence",
      workingHours: "Heures de travail",
      sections: "Sections",
      classes: "Classes",
      subjects: "Matières",
      modules: "Modules",
      permissions: "Permissions",
      userPermission: "Permissions utilisateur"
    }
  }
}

const savedLang = localStorage.getItem('lang')

const i18n = createI18n({
  legacy: false,
  locale: savedLang || (navigator.language.startsWith('fr') ? 'fr' : 'en'),
  fallbackLocale: 'en',
  messages
})

export default i18n